import type { Locale } from "./catalogs";

export type TranslationValue = string | number | boolean;
export type TranslationParams = Readonly<Record<string, TranslationValue>>;

export const interpolateTranslation = (
  template: string,
  params: TranslationParams = {},
): string => template.replace(/\{([A-Za-z0-9_]+)\}/gu, (match, key: string) =>
  Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match,
);

export const translateMessage = (
  catalog: Readonly<Record<string, string>>,
  key: string,
  params: TranslationParams = {},
): string => interpolateTranslation(catalog[key] ?? key, params);

export const translatePlural = (
  catalog: Readonly<Record<string, string>>,
  locale: Locale,
  key: string,
  count: number,
  params: TranslationParams = {},
  pluralRules = new Intl.PluralRules(locale),
): string => {
  const category = pluralRules.select(count);
  const resolvedKey = catalog[`${key}.${category}`] !== undefined
    ? `${key}.${category}`
    : catalog[`${key}.other`] !== undefined
      ? `${key}.other`
      : key;
  return interpolateTranslation(catalog[resolvedKey] ?? resolvedKey, { ...params, count });
};
